import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { tokenScopes } from "@coworker/apprestructured/src/assets/auth/msalConfig";
import { AppProviders } from "@coworker/apprestructured/src/layout/components/AppProviders/AppProviders";
import { AuthorizedUserRoute } from "@coworker/apprestructured/src/layout/components/AuthorizedUserRoute/AuthorizedUserRoute";
import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { EnsureUserTeamMembership } from "../EnsureUserTeamMembership/EnsureUserTeamMembership";
import { UserPermissions } from "../UserPermissions/UserPermissions";

export const MsalWrapper = () => {
  const scopes = ["openid", "profile", "email"];
  const authRequest = {
    scopes: [...tokenScopes, ...scopes],
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      loadingComponent={SimpleDefaultLoadingScreen}
      authenticationRequest={authRequest}
    >
      <UserPermissions>
        <AuthorizedUserRoute>
          <EnsureUserTeamMembership>
            <AppProviders />
          </EnsureUserTeamMembership>
        </AuthorizedUserRoute>
      </UserPermissions>
    </MsalAuthenticationTemplate>
  );
};
